(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-item', {
            parent: 'entity',
            url: '/purchase-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item/purchase-items.html',
                    controller: 'PurchaseItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItem');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-item-detail', {
            parent: 'entity',
            url: '/purchase-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-item/purchase-item-detail.html',
                    controller: 'PurchaseItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseItem');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseItem', function($stateParams, PurchaseItem) {
                    return PurchaseItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-item.new', {
            parent: 'purchase-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item/purchase-item-dialog.html',
                    controller: 'PurchaseItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                productPrice: null,
                                netPrice: null,
                                discountPercent: null,
                                discountPrice: null,
                                discountLinePercent: null,
                                discountLinePrice: null,
                                totalPrice: null,
                                taxPrice: null,
                                finalPrice: null,
                                comment: null,
                                quantityExecuted: null,
                                discountPurchasePercent: null,
                                discountPurchasePrice: null,
                                discountSummary: null,
                                taxPercent: null,
                                lotNumber: null,
                                pfs: null,
                                executedDiscountSummary: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-item', null, { reload: true });
                }, function() {
                    $state.go('purchase-item');
                });
            }]
        })
        .state('purchase-item.edit', {
            parent: 'purchase-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item/purchase-item-dialog.html',
                    controller: 'PurchaseItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseItem', function(PurchaseItem) {
                            return PurchaseItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-item.delete', {
            parent: 'purchase-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-item/purchase-item-delete-dialog.html',
                    controller: 'PurchaseItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseItem', function(PurchaseItem) {
                            return PurchaseItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
